import { useEffect, useRef, useState } from 'react'

import type { WarehouseSelection } from '@/hooks/useWarehouseSelection'

/** The table's header checkbox: checked selects every piece of the current filter, unchecked clears the selection. */
export function SelectAllCheckbox({ selection, total, onSelectAll }: {
  selection: WarehouseSelection
  total: number
  onSelectAll: (() => Promise<void>) | undefined
}) {
  const [busy, setBusy] = useState(false)
  const ref = useRef<HTMLInputElement | null>(null)
  const partial = selection.selectedCount > 0 && !selection.allMatching
  useEffect(() => {
    if (ref.current !== null) ref.current.indeterminate = partial
  }, [partial])
  const change = () => {
    if (selection.allMatching) {
      selection.clear()
      return
    }
    if (onSelectAll === undefined) return
    setBusy(true)
    void onSelectAll().finally(() => setBusy(false))
  }
  return <input
    ref={ref}
    type="checkbox"
    checked={selection.allMatching}
    disabled={busy || total === 0 || onSelectAll === undefined}
    aria-label="Выбрать все по фильтру"
    aria-busy={busy || undefined}
    title={`Выбрать все по фильтру: ${total.toLocaleString('ru-RU')}`}
    onChange={change}
  />
}
